/* eslint-disable import/no-extraneous-dependencies */
import { Link, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useState } from 'react'
import dayjs from 'dayjs'
import { ReturnIcon } from '../../assets/icons/Return'
import { TredingDownIcon } from '../../assets/icons/trending-down'
import { TrendingUpIcon } from '../../assets/icons/trending-up'
import { CardIconTitle } from '../../components/CardIconTitle/CardIconTitle'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { CardDashboard } from '../../components/CardDashboard/CardDashboard'
import { Loading } from '../../components/Loading/Loading'
// import { DivTitle } from '../../components/TitlePage/TitlePage'
import { colors } from '../../theme'
import {
  DivTablePaginacao,
  WrapperCardsResumo,
} from '../Dashboard/DashBoard.style'
import {
  ButtonHistoricoBaixa,
  Calendars,
  ContainerCard,
  DatePickerStyle,
  Div,
  DivButtonHistoricoBaixa,
  DivImg,
  DivName,
  DivTop,
  FiltersCalendar,
  IconDismiss,
  LinkWpp,
  Span,
  SpanData,
  TitleAndCalendar,
  TypesFilter,
  Wrapper,
} from '../PredictionDetails/PredictionDetails.style'
// import { WrapperTitle } from '../../layouts/LayoutTable/LayoutTable'
import { useClientDetails } from './useClientDetails'
import { MailIcon } from '../../assets/icons/mail'
import { PhoneIcon } from '../../assets/icons/phone-telephone'
import { WhatsappIcon } from '../../assets/icons/whatsapp-line'
import { usePredictionDetails } from '../PredictionDetails/usePredictionDetails'
import { UseFormatador } from '../../components/FormatadorCpfCnpj'
import { CheckOneIcon } from '../../assets/icons/check-one'
import { FacialRed } from '../../assets/icons/FacialRed'
import { HistoryIcon } from '../../assets/icons/history'
import SearchPlus from '../../assets/icons/searchPlus'
import DatesPicker from '../../components/Calendar/datePicker'
import { HistoricoDeBaixas } from '../../components/HistoricoDeBaixas'
import { PaginationHistoryPredict } from '../../components/Pagination/Pagination'
import { ProductDetailsPredictions } from '../../components/ProductDetailsPredictions'
import { MixRecomendacoes } from '../../components/MixRecomendacoes/MixRecomendacoes'
import { dateToBr } from '../../utils/transformDate'
import 'dayjs/locale/pt-br'
import { Button } from '../../components/SideBar/Menu.style'

export function ClientDetails() {
  const { clientResume, productsDetails, productsLow, isLoading } =
    useClientDetails()
  const {
    predictionHistory,
    predictionSoldOff,
    clientData,
    isLoadingHistory,
    isLoadingSoldOff,
    dismiss,
    currentPageHistory,
    currentPageSoldOff,
    setCurrentPageHistory,
    setCurrentPageSoldOff,
    setCalendarInicio,
    handleIsProductDetails,
    isProductDetails,
    consultar,
    productDetails,
    handleIsHistoricoBaixa,
    isHistoricoBaixa,
  } = usePredictionDetails()
  const { formatarCPF } = UseFormatador()

  const location = useLocation()
  const { pathname } = location
  const pathnameArray = pathname.split('/')

  const data = localStorage.getItem('dataInicio')

  const dataSelecionadaPredicao = data ? JSON.parse(data) : null
  // Guard igual ao que Predictions.tsx ja fazia: entrar DIRETO em /predicao/:id ou /cliente/:id
  // (link da aba "Clientes por potencial", que abre em aba nova, mas tambem F5 ou favorito) com o
  // localStorage sem `dataInicio` quebrava a tela em branco - `null.split` e o projeto nao tem
  // ErrorBoundary. Sem data gravada, cai em hoje.
  const dataFormatada = dataSelecionadaPredicao
    ? dataSelecionadaPredicao.split('/')
    : []
  const dataValida = dataSelecionadaPredicao
    ? `${dataFormatada[1]}/${dataFormatada[0]}/${dataFormatada[2]}`
    : ''
  const formatData = dataValida ? dayjs(dataValida) : dayjs()

  const dataProximaCompra = formatData.format('DD/MM/YYYY')
  const [dateStart, setDateStart] = useState(dataProximaCompra)

  return (
    <>
      <ToastContainer theme="dark" />
      <DivTop>
        {/* Mesma regra do ProductsDetails: o voltar segue a origem gravada na PROPRIA rota.
            /clientes/:id veio da lista de Clientes; /dashboard/cliente/:id veio do Dashboard.
            O /cliente/:id legado (favorito antigo) cai no else e volta para o Dashboard, como
            sempre voltou. Desde 2026-09-10 VENDEDOR e ASSISTENTE TAMBEM tem a tela de Clientes,
            mas o destino continua sendo a origem, nao o papel: quem entrou por um link antigo
            nao veio de /clientes e nao deveria ser levado para la. */}
        <Link
          to={pathnameArray.includes('clientes') ? '/clientes' : '/dashboard'}
        >
          <ReturnIcon />
        </Link>
        <Span>Detalhamento</Span>
      </DivTop>
      <DivImg>
        {isLoading ? (
          <Loading contrast />
        ) : (
          <>
            <DivName>{clientData?.nome}</DivName>
            <SpanData>CPF / CNPJ: {formatarCPF(clientData?.cpfcnpj)}</SpanData>
            <SpanData>
              <PhoneIcon /> {clientData?.telefone}
              <MailIcon /> {clientData?.email}
              <WhatsappIcon />
              <LinkWpp
                href={`https://web.whatsapp.com/send?phone=${clientData?.whatsapp}`}
                target="_blank"
              >
                {clientData?.whatsapp}
              </LinkWpp>
            </SpanData>
          </>
        )}
      </DivImg>

      {isLoading ? (
        <Loading contrast={false} />
      ) : (
        <WrapperCardsResumo>
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.grey200}
            total={clientResume?.media120Dias}
          >
            Média 180 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={clientResume?.ultimos30Dias}
            percentage={clientResume?.percentualUltimos30Dias}
          >
            Últimos 30 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={clientResume?.ultimos60Dias}
          >
            Últimos 60 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={clientResume?.ultimos90Dias}
          >
            Últimos 90 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={clientResume?.ultimos120Dias}
          >
            Últimos 120 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={clientResume?.ultimos150Dias}
          >
            Últimos 150 dias
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.grey900}
            color={colors.primaryText}
            background={colors.surface}
            total={clientResume?.ultimos180Dias}
          >
            Últimos 180 dias
          </CardDashboard>
        </WrapperCardsResumo>
      )}
      <Div>
        <Wrapper size="49">
          <ContainerCard>
            <CardIconTitle
              icon={<TrendingUpIcon />}
              background={colors.secondary}
              title="Produtos em alta"
            />
          </ContainerCard>
          <GenericTable
            font="14px"
            spacing="20px"
            headers={['Produto', 'Percentual']}
          >
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              productsDetails.map(details => (
                <tr key={details.id}>
                  <td className="col2">{details.nome}</td>
                  <td className="col3">{details.percentual}%</td>
                </tr>
              ))
            )}
          </GenericTable>
        </Wrapper>
        <Wrapper size="49">
          <ContainerCard>
            <CardIconTitle
              icon={<TredingDownIcon />}
              background={colors.error}
              title="Produtos em baixa"
            />
          </ContainerCard>
          <GenericTable
            font="14px"
            spacing="20px"
            headers={['Produto', 'Percentual']}
          >
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              productsLow.map(item => (
                <tr key={item.id}>
                  <td className="col2">{item.nome}</td>
                  <td className="col3">{item.percentual}%</td>
                </tr>
              ))
            )}
          </GenericTable>
        </Wrapper>
      </Div>
      <MixRecomendacoes />
      <Div id="finalizacaoPredicao">
        <Wrapper alinhamento className="firstCard">
          <ContainerCard>
            <TitleAndCalendar>
              <CardIconTitle
                icon={<HistoryIcon />}
                background={colors.grey200}
                title="Histórico"
              />
            </TitleAndCalendar>
          </ContainerCard>
          <>
            <GenericTable
              font="14px"
              spacing="20px"
              headers={[
                // 'ID',
                'Produto',
                'Última compra',
                'Qtd.',
              ]}
              title4
            >
              {isLoadingHistory ? (
                <Loading contrast={false} />
              ) : (
                predictionHistory &&
                Array.isArray(predictionHistory.content) &&
                predictionHistory.content.map(item => (
                  <tr key={item.id}>
                    {/* <td>{item.id}</td> */}
                    <td className="col2">{item.nome}</td>
                    <td className="col3">{dateToBr(item.ultimaCompra)}</td>
                    <td className="colVendas6">{item.quantidade}</td>
                  </tr>
                ))
              )}
            </GenericTable>
            <PaginationHistoryPredict
              pageNumber={currentPageHistory}
              pageSize={predictionHistory.totalElements}
              offSet={predictionHistory.size}
              onClick={page => setCurrentPageHistory(page)}
            />
          </>
        </Wrapper>
        <Wrapper alinhamento className="secondCard">
          <DivTablePaginacao>
            <TitleAndCalendar>
              <CardIconTitle
                icon={<FacialRed />}
                background={colors.lightRed}
                title="Produtos esgotando"
                color={colors.errorText}
              />
              <TypesFilter>
                <FiltersCalendar type="button">
                  <Calendars>
                    <DatePickerStyle>
                      Data:
                      <DatesPicker
                        handleDataSelecionada={setDateStart}
                        size="130px"
                        dayjs={formatData}
                        background
                      />
                    </DatePickerStyle>
                    <Button
                      buttonType="SMALL"
                      type="button"
                      onClick={() => {
                        setCalendarInicio(dateStart)
                      }}
                    >
                      Aplicar
                    </Button>
                  </Calendars>
                </FiltersCalendar>
              </TypesFilter>
            </TitleAndCalendar>
            <GenericTable
              font="14px"
              spacing="20px"
              headers={[
                // 'ID',
                'Produto',
                'Última compra',
                'Próx. compra',
                // 'Qtd.',
                'Consultar',
                'Dar Baixa',
              ]}
            >
              {isLoadingSoldOff ? (
                <Loading contrast={false} />
              ) : (
                predictionSoldOff.content &&
                Array.isArray(predictionSoldOff.content) &&
                predictionSoldOff.content.map(item => (
                  <tr id="darBaixa" key={item.id}>
                    {/* <td>{item.id}</td> */}
                    <td className="colPredictionDetails">{item.nome}</td>
                    <td className="col3">{dateToBr(item.ultimaCompra)}</td>
                    <td className="col3">{dateToBr(item.proximaCompra)}</td>
                    {/* <td className="colVendas">{item.quantidade}</td> */}
                    <td className="colVendas6">
                      <IconDismiss onClick={() => consultar(item.id)}>
                        <SearchPlus />
                      </IconDismiss>
                    </td>
                    <td className="colVendas6">
                      <IconDismiss
                        onClick={() => {
                          dismiss(item.id, item.proximaCompra)
                        }}
                      >
                        <CheckOneIcon />
                      </IconDismiss>
                    </td>
                  </tr>
                ))
              )}
            </GenericTable>
          </DivTablePaginacao>
          <DivButtonHistoricoBaixa>
            <ButtonHistoricoBaixa
              onClick={() => {
                handleIsHistoricoBaixa()
              }}
              id="anexar"
              htmlFor="files"
            >
              <HistoryIcon />
              Histórico de baixas
            </ButtonHistoricoBaixa>

            <PaginationHistoryPredict
              pageNumber={currentPageSoldOff}
              pageSize={predictionSoldOff.totalElements}
              offSet={predictionSoldOff.size}
              onClick={page => setCurrentPageSoldOff(page)}
            />
          </DivButtonHistoricoBaixa>
        </Wrapper>
        {isHistoricoBaixa && (
          <HistoricoDeBaixas handleIsHistoricoBaixa={handleIsHistoricoBaixa} />
        )}
        {isProductDetails && (
          <ProductDetailsPredictions
            consumoMedioDiario={productDetails.consumoMedioDiario}
            dataCompraAntiga={productDetails.dataCompraAntiga}
            dataCompraRecente={productDetails.dataCompraRecente}
            diasConsumo={productDetails.diasConsumo}
            duracaoUltimaCompra={productDetails.duracaoUltimaCompra}
            nome={productDetails.nome}
            predicaoProximaCompra={productDetails.predicaoProximaCompra}
            quantidadeUltimaCompra={productDetails.quantidadeUltimaCompra}
            reposicaoTotal={productDetails.reposicaoTotal}
            handleIsProductDetails={handleIsProductDetails}
          />
        )}
      </Div>
    </>
  )
}
